export default __webpack_public_path__ + "static/media/techMaturity.307d7cbc.svg";